import { isNgServe } from '@core';

import { Environment } from './type';

export const environment: Environment = {
  name: 'Oongalee Lumen - DEV',
  machineName: 'dev',
  production: true,
  serviceWorker: !isNgServe,
  debug: true,
  apiUrl: 'https://oongalee-exscuseme-srv-dev.r2.danavero.com',
  socketApi: 'wss://oongalee-exscuseme-srv-dev.r2.danavero.com',
  sentry: {
    dsn: '',
  },
  backgroundPlayer: null,
  backgroundAdPlayer: 'https://ad.apps.dwall.online',
  backgroundAdPlayerColor: '#191919',
  update: {
    checkStrategy: 'every-minute',
    activateStrategy: 'restart-when-idle',
  },
  featureToggle: {
    idleClickGoTo: ['/main/home'],
    withTabBar: true,
    withCallWaiter: {
      main: true,
      secondary: true,
      tertiary: true,
    },
    withCallWaiterOnOffline: true,
    withInvoice: false,
    withServiceCentre: false,
    tabBarAutoHide: false,
    idleDelay: 30,
    ambientLight: {
      glowAnimation: true,
      callWaiter: {
        main: { r: 255, g: 0, b: 0, a: 1 },
        secondary: { r: 0, g: 255, b: 0, a: 1 },
        tertiary: { r: 255, g: 255, b: 0, a: 1 },
      },
    },
  },
};
